/**
 * 判斷是否顯示 Badge
 *
 * @param source: string
 * @returns boolean
 */

import { EnumSource } from '@/assets/types/api/Search';

const provideIsShowBadge = (source: string): boolean => {
  return !!(source === EnumSource.PRODUCTS || source === EnumSource.SOLUTION);
};

export default provideIsShowBadge;
